// Color utilities for accessible text contrast on colored backgrounds

function hexToRgb(hex) {
  if (!hex) return { r: 0, g: 0, b: 0 };
  let cleaned = hex.replace('#', '');
  if (cleaned.length === 3) {
    cleaned = cleaned.split('').map(c => c + c).join('');
  }
  const r = parseInt(cleaned.substring(0, 2), 16);
  const g = parseInt(cleaned.substring(2, 4), 16);
  const b = parseInt(cleaned.substring(4, 6), 16);
  return { r, g, b };
}

function srgbToLinear(c) {
  const cs = c / 255;
  return cs <= 0.03928 ? cs / 12.92 : Math.pow((cs + 0.055) / 1.055, 2.4);
}

export function getRelativeLuminance(hex) {
  const { r, g, b } = hexToRgb(hex);
  const R = srgbToLinear(r);
  const G = srgbToLinear(g);
  const B = srgbToLinear(b);
  // WCAG relative luminance
  return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}

export function getContrastRatio(hexA, hexB) {
  const L1 = getRelativeLuminance(hexA);
  const L2 = getRelativeLuminance(hexB);
  const [light, dark] = L1 > L2 ? [L1, L2] : [L2, L1];
  return (light + 0.05) / (dark + 0.05);
}

// Returns '#000' or '#fff' whichever meets better contrast against bg.
// Optimized for calendar colors which are typically vibrant and work better with white text
export function getAccessibleTextColor(bgHex) {
  if (!bgHex) return '#000000';
  
  // Clean the hex value
  const hex = bgHex.replace('#', '');
  
  // For very light colors (near white), use black text
  if (hex.toLowerCase() === 'ffffff' || hex.toLowerCase() === 'white') {
    return '#000000';
  }
  
  // Calculate luminance using a simpler, more aggressive formula for calendar colors
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  // Use a more aggressive threshold that favors white text for colorful backgrounds
  // Standard formula but with lower threshold for calendar app usage
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
  // Use white text for most colored backgrounds (threshold of 0.7 instead of 0.5)
  // This ensures calendar colors like reds, blues, greens get white text
  return luminance > 0.7 ? '#000000' : '#ffffff';
}

export default {
  getRelativeLuminance,
  getContrastRatio,
  getAccessibleTextColor,
};


